import { render, staticRenderFns } from "./Thesis.vue?vue&type=template&id=bc4cd300&scoped=true&"
import script from "./Thesis.vue?vue&type=script&lang=js&"
export * from "./Thesis.vue?vue&type=script&lang=js&"
import style0 from "./Thesis.vue?vue&type=style&index=0&id=bc4cd300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4cd300",
  null
  
)

export default component.exports